import { IStory } from "../model";
import { IStoryMeta } from "../model/story-meta.model";

export const storyInitialValues: IStory = {
  storyId: 0,
  languageCode: "",
  title: "",
  illustrator: "",
  horizontal: "",
  fileProfiles: [{ fileProfile: "", filePath: "" }],
  description: "",
  basePath: "",
  author: "",
  storyTypeId: 0,
  storyDetailId: 0,
  mainCategoryId: 0,
  mobileCover: "",
  readAloud: false,
  readBy: "",
  tabletCover: "",
  thumbnail: "",
  translator: "",
  categories:"",
  categoryIds:[]
};

export const storyMetaInitialValues:IStoryMeta = {
  activity: '',
  gradeLevels: [],
  pypThemes: [],
  terms: []
}
